import AccessibleHighlightedText from '../AccessibleHighlightedText'

import { useSimulationResult } from './useSimulationResult'

const FgtsAmount = () => {
  const { fgtsText } = useSimulationResult()

  return <AccessibleHighlightedText color="dark-medium" {...fgtsText} />
}
export default FgtsAmount
